import { createAuth0Client } from "@auth0/auth0-spa-js";

export default defineNuxtPlugin({
  name: "auth0",
  async setup(app) {
    const auth0Client = await createAuth0Client({
      domain: app.$config.public.auth0domain || "",
      clientId: app.$config.public.auth0clientId || "",
      authorizationParams: {
        redirect_uri: window.location.origin + "/auth",
      },
    });

    return { provide: { auth0: auth0Client } };
  },
});
